import React from "react";
import { DatePicker, Form, Input, Select } from "antd";
import ImageComponent from "./useAttachments";
import GetRevisions from "./getRevisions";

const { Option } = Select;
const { TextArea } = Input;

const RevisionsEditableCell = ({
  cell,
  images,
  setImages,
  attachPopupVisible,
  setAttachPopupVisible,
  currentUpdateObj,
}) => {
  const {
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  } = cell;

  let inputNode;

  const [revOptions] = GetRevisions();

  switch (dataIndex) {
    case "distribution_date":
      inputNode = (
        <DatePicker size="small" suffixIcon={null} allowClear={false} />
      );
      break;
    case "username":
      inputNode = (
        <Input readOnly className="border-less-input" placeholder="" />
      );
      break;
    case "rev":
      inputNode = (
        <Select
          showSearch
          //   className="activities-selector"
          getPopupContainer={() =>
            document.getElementsByClassName(
              "ant-layout-content layout-content site-layout-background custom-textarea"
            )[0]
          }
          dropdownClassName="select-dropdown-custom"
          placeholder="Rev"
          size="small"
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {revOptions.map(({ value, label }) => (
            <Option key={value} value={value}>
              {label}
            </Option>
          ))}
        </Select>
      );
      break;
    case "issued_by":
      inputNode = <Input placeholder="Issued By" size="small" />;
      break;
    case "issued_to":
      inputNode = <Input placeholder="Issued To" size="small" />;
      break;
    case "no_of_copies":
      inputNode = <Input placeholder="No" size="small" />;
      break;
    case "copy_size":
      inputNode = <Input placeholder="Copies Size" size="small" />;
      break;

    case "transmittal_no":
      inputNode = <TextArea rows={2} placeholder="Transmittal Number" />;
      break;

    case "images":
      inputNode = (
        <ImageComponent
          images={images}
          setImages={setImages}
          attachPopupVisible={attachPopupVisible}
          setAttachPopupVisible={setAttachPopupVisible}
          currentUpdateObj={currentUpdateObj}
        />
      );
      break;
    default:
      break;
  }

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[
            {
              required: dataIndex === "images" ? false : true,
              message: ``, // Required!
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

export default RevisionsEditableCell;
